import {Injectable} from '@angular/core';
import {HttpCommonService} from "./http-common.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class SuperviseService {

  constructor(private http: HttpCommonService) {
  }

  /**
   * 监管企业
   * @param {string} companyId
   * @returns {Observable<any>}
   */
  supervise(companyId: string): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/supervise/superviseCompany', {companyId: companyId});
  }

  /**
   * 取消监管企业
   * @param {string} companyId
   * @returns {Observable<any>}
   */
  unSupervise(companyId: string): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/supervise/unSuperviseCompany', {companyId: companyId});
  }

  /**
   * 查询监管列表
   * @param params
   * @returns {Observable<any>}
   */
  getSuperviseList(params: any): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/supervise/getSuperviseList', {
      companyName: params.companyName ? params.companyName : '',
      pageNo: params.page.pageNo,
      pageSize: params.page.pageSize
    });
  }

  /**
   * 移除监管
   * @param {string} superviseIds
   * @returns {Observable<any>}
   */
  removeSupervise(superviseIds: string): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/supervise/removeSupervise', {superviseIds: superviseIds});
  }

  /**
   * 是否监管中
   * @param {string} companyId
   * @returns {Observable<any>}  0：监管中 -1：未监管
   */
  hasSupervise(companyId: string): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/supervise/hasSupervise', {companyId: companyId});
  }

  /**
   * 获取所有监测类型
   */
  getAllMonitorType(): Observable<any> {
    return this.http.get('/enterprise/detail/monitor/getAllMonitorType');
  }

  /**
   * 获取监管推送方式
   * @returns {Observable<any>}
   */
  getSupervisePushWay(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/supervise/getSupervisePushWay');
  }

  /**
   * 设置监管推送方式
   * @param {any} params
   * @returns {Observable<any>}
   */
  setSupervisePushWay(params: any): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/supervise/setSupervisePushWay', params);
  }

  /**
   * 单条添加监测
   * @param {string} companyIds
   * @returns {Observable<any>}
   */
  addSuperviseOneByOne(companyIds: string): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/supervise/addSuperviseOneByOne', {companyIds: companyIds});
  }

  /**
   * 获取监测企业条数
   * @returns {Observable<any>}
   */
  getSuperviseAmount(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/supervise/getSuperviseAmount');
  }

  /**
   * 是否可以添加监测
   * @returns {Observable<any>}
   */
  isAddSupervise(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/supervise/isAddSupervise');
  }

  /**
   * 批量导入
   * @param params
   * @returns {any}
   */
  importSupervise(params) {
    return this.http.post('/enterprise/detail/xhsRest/supervise/importSupervise', params);
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/supervise.service.ts